module.exports = __webpack_public_path__ + "img/miljoval.57c9eb37.jpg";